window.ExtPaypal = {
	
	/**
	 * PREFS
	 */
	loadPrefs : function(){
		var options = {
			title	: Loc.g("Préférences Paypal"),
			buttons	: [
                { text: Loc.g("Fermer"), class: 'btn btn-default', click :function(){MyWindow.close();}},
                { text: Loc.g("Enregistrer"), class: 'btn btn-primary', click : function(){$('#extPaypalForm').submit();}}
			],
			callback	: function(){ExtPaypal.preparePrefsForm();},
			width: 500
		};
		
		var fileOpt = {action:""};
		MyWindow.load("paypal_prefs", fileOpt, options);
	},
	
	preparePrefsForm : function(){
		var formId = "extPaypalForm";
		var options = {
			success:function(data){ExtPaypal.recordCallback(data);}, 
			dataType:"json"
		};
		MyForm.prepare(formId, "paypal_prefs&action=record", options, true);
		MyFacture.initEvent("#"+formId);
		
	},
	
	recordCallback : function(data){
		var formIsOk = MyForm.processJson(data, "extPaypalForm", "popupWindow");
		if (formIsOk){
			Utils.reload();
		}
	}

};